export default __webpack_public_path__ + "static/media/Lathe of Stars.b5b36b40.jpg";